export interface SettingsGearIconProps {
  /** Rendered width in px; height follows the artwork's aspect ratio. */
  width?: number;
  /** Gear-with-red-dot variant, shown while notifications are unread. */
  badge?: boolean;
}

/**
 * Settings gear — solo gear normally, gear + red dot while notifications are
 * unread. Artwork supplied by design (gear #FFFFFF, dot #C1272D); paths used
 * verbatim from the two Illustrator exports. Each variant is framed on its
 * own union bounds: solo gear 156.48x153.97, badge union 173.27x164.53 with
 * the gear translated 10.56 down to make room for the dot at top-right.
 */
export function SettingsGearIcon({ width = 16, badge = false }: SettingsGearIconProps) {
  const height = Math.round(width * (badge ? 164.53 / 173.27 : 153.97 / 156.48));

  if (badge) {
    return (
      <svg
        width={width}
        height={height}
        viewBox='0 0 173.27 164.53'
        fill='none'
        style={{ display: 'block', flexShrink: 0 }}
        aria-hidden='true'
      >
        <path
          fill='#FFFFFF'
          d='M154.64,80.58c-4.2-6.73-17.11-3.13-21.23-12.47-4.59-10.4,8.57-17.08,5.54-24.97-1.58-4.11-5.67-8.18-9.72-10.35-7.22-3.86-15.49,8.51-27.21,3.04-13.44-6.27-3.63-25.88-24.38-25.26-19.46.58-9.37,19.08-22.37,25.28-14.02,6.69-20.9-12.19-32.85,1.58-11.3,13.01,6.11,18.51,1.28,29.44-4.85,10.99-18.13,6.45-22.06,13.69-2.08,3.82-2.15,10.41-.39,14.55,3.2,7.53,17.54,3.51,22.62,13.88,6.31,12.86-7.07,19.97-4.19,28.46,1.48,4.38,6.48,8.91,10.99,9.96,7.4,1.72,14.36-11.07,26.33-5.99,10.91,4.63,6.35,16.08,14.58,23.13h13.05c8.72-5.88,3.38-18.25,15.31-23.32,11.91-5.07,20.29,8.77,27.29,5.87,3.8-1.57,7.74-5.57,9.8-9.01,4.64-7.74-10.08-15.14-4.64-28.14,4.75-11.34,19.2-7.24,22.74-14.85,1.88-4.05,1.84-10.76-.49-14.5ZM90.6,120.39c-14.59,5.43-30.22,1.14-40.24-10.59-10.71-12.56-11.06-31.26-.49-43.98,9.84-11.83,25.28-16.57,39.92-11.32,12.94,4.64,23.6,16.75,23.83,32.52.23,15.95-9.97,28.52-23.03,33.38Z'
        />
        <circle cx='137.44' cy='35.83' r='35.83' fill='#C1272D' />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 156.48 153.97'
      fill='none'
      style={{ display: 'block', flexShrink: 0 }}
      aria-hidden='true'
    >
      <path
        fill='#FFFFFF'
        d='M154.64,70.02c-4.2-6.73-17.11-3.13-21.23-12.47-4.59-10.4,8.57-17.08,5.54-24.97-1.58-4.11-5.67-8.18-9.72-10.35-7.22-3.86-15.49,8.51-27.21,3.04C88.58,19,98.39-.6,77.64.01c-19.46.58-9.37,19.08-22.37,25.28-14.02,6.69-20.9-12.19-32.85,1.58-11.3,13.01,6.11,18.51,1.28,29.44-4.85,10.99-18.13,6.45-22.06,13.69-2.08,3.82-2.15,10.41-.39,14.55,3.2,7.53,17.54,3.51,22.62,13.88,6.31,12.86-7.07,19.97-4.19,28.46,1.48,4.38,6.48,8.91,10.99,9.96,7.4,1.72,14.36-11.07,26.33-5.99,10.91,4.63,6.35,16.08,14.58,23.13h13.05c8.72-5.88,3.38-18.25,15.31-23.32,11.91-5.07,20.29,8.77,27.29,5.87,3.8-1.57,7.74-5.57,9.8-9.01,4.64-7.74-10.08-15.14-4.64-28.14,4.75-11.34,19.2-7.24,22.74-14.85,1.88-4.05,1.84-10.76-.49-14.5ZM90.6,109.83c-14.59,5.43-30.22,1.14-40.24-10.59-10.71-12.56-11.06-31.26-.49-43.98,9.84-11.83,25.28-16.57,39.92-11.32,12.94,4.64,23.6,16.75,23.83,32.52.23,15.95-9.97,28.52-23.03,33.38Z'
      />
    </svg>
  );
}
